import { AppResourcePage } from './app-resource-base';
import { branchSwitchOnResource } from './helpers/branch-switch';
import {
  createPurchaseOrderView,
  getPurchaseOrderContainer,
  getPurchaseOrderContainerManager,
  PurchaseOrderLock
} from '../purchase-orders/purchase-order-ui-adapter';
import { customElement } from 'lit/decorators.js';
import { goStaticURL } from '../../../webmodule-common/other/ui/resource-resolver';
import { isEmptyOrSpace } from '../../../webmodule-common/other/ui/string-helper-functions';
import { ModalViewBase } from '../../../webmodule-common/other/ui/data-entry-screen-base';
import { NullPromise } from '../../../webmodule-common/interop/types/misc';
import { ResourceLocker } from '../common/resource-lock';
import { tlang } from '../../../webmodule-common/other/language/lang';

@customElement('app-purchase-order')
export class AppPurchaseOrderPage extends AppResourcePage {
  async createModalEditor(orderId: string): NullPromise<ModalViewBase> {
    const container = getPurchaseOrderContainer(orderId);
    if (isEmptyOrSpace(orderId)) orderId = container.purchaseOrderId;

    const qm = getPurchaseOrderContainerManager(container, () => !this.lock?.isLockOwner);
    await qm.needsPurchaseOrder();

    if (!(await branchSwitchOnResource(qm.quoteOwnerId, tlang`%%purchase-order%%`))) return null;

    return await createPurchaseOrderView(qm);
  }

  async redirectPath(): NullPromise<string> {
    return '/purchase-orders';
  }

  meta() {
    return {
      title: tlang`%%purchase-order%% Editor`,
      description: 'SoftTech dealer CPQ'
    };
  }

  protected createLock(id: string): ResourceLocker | undefined {
    return new PurchaseOrderLock(id, async () => {
      await this.view?.abandonAndClose(true);
      goStaticURL('/purchase-orders');
    });
  }
}
